import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { PrismicRichText } from '@prismicio/react'
import SellingForm from './forms/selling'

const Selling = ({ location, slice }) => {
  return (
    <section className='component-selling bg-brand-blue'>
      <div className='grid gap-6 md:grid-cols-2 mx-auto w-full max-w-screen-xl p-6'>
        <div className='relative z-10 mx-4 flex items-start md:mx-0'>
          <div className='text-white sticky top-0 py-6 z-10'>
            <div className='prose prose-invert'>
              <PrismicRichText field={slice.primary.text.richText} />
            </div>
            <ul className='flex flex-col gap-3 mt-12'>
              {slice.items.map((icon, index) => {
                return (
                  <li className='flex text-xl items-center gap-6' key={`icon-${index}`}>
                    <div className='rounded-md bg-brand-orange icon w-16'>
                      <GatsbyImage className='m-3' image={icon.icon.gatsbyImageData} alt={icon.icon.alt || ''} />
                    </div>
                    {icon.icon_copy}
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
        <div className='relative z-10 md:-mt-16 md:-mb-12'>
          <SellingForm location={location} />
        </div>
      </div>
    </section>
  )
}

export default Selling
